import type { ScoreLandingPageResponse } from "./scoreLandingPage.types";

export const SCORE_LANDING_PAGE_FALLBACK: ScoreLandingPageResponse = {
  ambitions: ["Engineering", "Medical", "Not Decided Yet", "Others"],
  orderedWidgets: [
    {
      id: "aboutScore",
      order: 1,
      beforeRegistrationWidget: true,
      afterRegistrationWidget: false,
      response: {
        image: {
          src: "https://assets.infinitylearn.com/ILScore2026/landingpage/what_score.webp",
          alt: "SCORE 2026 — India's largest scholarship exam for grades 3 to 12 presented by Sri Chaitanya",
        },
        video_link:
          "https://assets.infinitylearn.com/Score26/videos/what_score.mp4",
        title: {
          desktop: {
            prefix: "",
            title: "More Than Just an Exam",
          },
          mobile: {
            title: "More Than Just an Exam",
          },
        },
        desktop: {
          video_link:
            "https://assets.infinitylearn.com/Score26/videos/what_score.mp4",
          video_thumbnail:
            "https://assets.infinitylearn.com/ILScore2026/landingpage/what_score.webp",
        },
        mobile: {
          video_link:
            "https://assets.infinitylearn.com/Score26/videos/what_score.mp4",
          video_thumbnail:
            "https://assets.infinitylearn.com/ILScore2026/landingpage/what_score.webp",
        },
        descriptions: [
          "Every topper was once a kid with potential. Sri Chaitanya chose to believe it first. SCORE Online is where it begins.",
          "This is the same belief that has helped millions of students succeed for 41 years and counting. SCORE Online is a national talent exam for students in <strong>Grades 4 to 12,</strong> designed to discover your child’s true potential and give them the right direction early on.",
          "By taking SCORE Online, your child can secure up to 100% scholarship on Infinity Learn’s online learning programs and access expert-led preparation from anywhere.",
          "<strong>Exam Date: </strong> From 20th August 2026 onwards – take the exam anytime between 9 AM and 9 PM on the exam day.",
          "<strong>Exam Mode: </strong> 100% Online",
        ],
        registerButton: "Register Now",
      },
    },
    {
      id: "whyScore",
      order: 2,
      beforeRegistrationWidget: true,
      afterRegistrationWidget: false,
      response: {
        title: "Why SCORE?",
        items: [
          {
            title: "Digital exam environment",
            description:
              "Built on the proven academic approach behind some of India's leading JEE, NEET, and school-level achievers, SCORE Online gives your child a strong starting point for future success.",
            image: {
              src: "whyScoreExamIcon",
              alt: "Real exam environment with OMR-based online exam at Infinity Learn Online Exam Platform",
            },
          },
          {
            title: "Compete Nationally and win Scholarship",
            description:
              "Discover where your child stands nationally by competing with students from across India—all from the comfort of home.",
            image: {
              src: "whyScoreScholarshipIcon",
              alt: "Compete nationally and win scholarships through SCORE",
            },
          },
          {
            title: "Identify Learning Gaps ",
            description:
              "Receive meaningful insights into your child’s strengths and weak areas, so they know exactly where to focus and improve. ",
            image: {
              src: "whyScoreGapsIcon",
              alt: "Evaluate academic readiness for JEE and NEET with SCORE",
            },
          },
          {
            title: "Evaluate your academic readiness",
            description:
              "Designed by Infinity Learn's expert faculty, SCORE Online evaluates conceptual understanding and readiness for school as well as competitive exams such as JEE and NEET.",
            image: {
              src: "whyScoreAcademicIcon",
              alt: "Evaluate academic readiness for JEE and NEET with SCORE",
            },
          },
        ],
      },
    },
    {
      id: "whyRegister",
      order: 3,
      beforeRegistrationWidget: true,
      afterRegistrationWidget: false,
      response: {
        title: "Benefits",
        items: [
          {
            title: "NASA Educational Trips",
            description:
              "Top performers can earn the opportunity to visit NASA and experience the world of space science up close.",
            icon: "benefitsRocketIcon",
          },
          {
            title: "350 Cr worth Scholarships",
            description:
              "Earn up to 100% scholarship on Infinity Learn's online learning programs.",
            icon: "benefitsScholarshipIcon",
          },
          {
            title: "2.5 Cr Cash Pool",
            description:
              "Secure a top rank and stand a chance to win exciting cash rewards.",
            icon: "benefitsCashPoolIcon",
          },
          {
            title: "Exciting Gadgets",
            description:
              "High achievers can also win laptops, tablets, and other smart devices designed to support their learning journey.",
            icon: "benefitsExcitingGadgetsIcon",
          },
        ],
      },
    },
    {
      id: "syllabus",
      order: 4,
      afterRegistrationWidget: true,
      beforeRegistrationWidget: true,
      response: {
        title: {
          desktop: {
            title: "Know Exactly What to Prepare",
          },
          mobile: {
            title: "Know what to prepare",
          },
        },
        downloadButtonText: "Attempt mock test",
        isButtonVisible: true,
        aboutTest: {
          details: [
            {
              grade: 4,
              exams: [
                {
                  exam: "CBSE",
                  duration: "Duration: <strong>60 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-4.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "60 questions – 20 questions per subject (Mathematics, Science, English)",
                    "Single correct MCQ",
                    "+1 for correct answer; no negative marking for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br> <strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-4.pdf",
                    points: ["Mathematics", "Science", "English"],
                  },
                  mindMaps: [],
                  formulaSheets: [],
                },
              ],
            },
            {
              grade: 5,
              exams: [
                {
                  exam: "CBSE",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-5.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "75 questions – 25 questions in Mathematics, 25 questions in Science (Physics 8, Chemistry 8, Biology 9), 25 questions in IQ",
                    "Single Correct MCQ",
                    "+2 for correct answer; no negative marking for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-5.pdf",
                    points: [
                      "Mathematics",
                      "Physics",
                      "Chemistry",
                      "Biology",
                      "IQ / Critical Reasoning",
                    ],
                  },
                  mindMaps: [],
                  formulaSheets: [],
                },
              ],
            },
            {
              grade: 6,
              exams: [
                {
                  exam: "Foundation Test",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "75 questions – 25 questions in Mathematics, 25 questions in Science (Physics 8, Chemistry 8, Biology 9), 25 questions in IQ",
                    "Single correct MCQ",
                    "+2 for correct answer; no negative marking for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                    points: [
                      "Mathematics",
                      "Physics",
                      "Chemistry",
                      "Biology",
                      "IQ / Critical Reasoning",
                    ],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Math",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              grade: 7,
              exams: [
                {
                  exam: "Foundation Test",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-7.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "75 questions – 25 questions in Mathematics, 25 questions in Science (Physics 8, Chemistry 8, Biology 9), 25 questions in IQ",
                    "Single Correct MCQ",
                    "+2 for correct answer; no negative marking for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-7.pdf",
                    points: [
                      "Mathematics",
                      "Physics",
                      "Chemistry",
                      "Biology",
                      "IQ / Critical Reasoning",
                    ],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Math",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              grade: 8,
              exams: [
                {
                  exam: "Foundation Test",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-8.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "60 questions",
                    "Section 1 -Single Correct MCQ; Section 2 - Multiple Correct MCQ",
                    "Section 1 (Single Correct): +3 for correct answer, 0 for incorrect answer; Section 2 (Multiple Correct): +4 for correct answer, 0 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-8.pdf",
                    points: [
                      "Mathematics",
                      "Physics",
                      "Chemistry",
                      "Biology",
                      "IQ",
                    ],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Math",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              grade: 9,
              exams: [
                {
                  exam: "Foundation Test",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-9.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "60 questions",
                    "Section 1 -Single Correct MCQ; Section 2 - Multiple Correct MCQ",
                    "Section 1 (Single Correct): +3 for correct answer, 0 for incorrect answer; Section 2 (Multiple Correct): +4 for correct answer, 0 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-9.pdf",
                    points: [
                      "Mathematics",
                      "Physics",
                      "Chemistry",
                      "Biology",
                      "IQ",
                    ],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Math",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              grade: 10,
              exams: [
                {
                  exam: "Foundation  Test",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-10.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "60 questions",
                    "Section 1 -Single Correct MCQ; Section 2 - Multiple Correct MCQ",
                    "Section 1 (Single Correct): +3 for correct answer, 0 for incorrect answer; Section 2 (Multiple Correct): +4 for correct answer, 0 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-10.pdf",
                    points: [
                      "Mathematics",
                      "Physics",
                      "Chemistry",
                      "Biology",
                      "IQ",
                    ],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Science",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Math",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              grade: 11,
              exams: [
                {
                  exam: "JEE Main",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-11-jee.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "60 questions – 20 questions per subject (Physics, Chemistry, Mathematics)",
                    "Single Choice MCQs",
                    "+4 for correct answer; -1 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-11-jee.pdf",
                    points: ["Mathematics", "Physics", "Chemistry"],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
                {
                  exam: "NEET",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-11-neet.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "120 questions – 30 questions per subject (Physics, Chemistry, Botany, Zoology)",
                    "Single Choice MCQs",
                    "+4 for correct answer; -1 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-11-neet.pdf",
                    points: ["Physics", "Chemistry", "Botany", "Zoology"],
                  },
                  mindMaps: [
                    {
                      subjectName: "Biology",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Biology",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              grade: 12,
              exams: [
                {
                  exam: "JEE Main",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-12-jee.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "60 questions – 20 questions per subject (Physics, Chemistry, Mathematics)",
                    "Single Choice MCQs",
                    "+4 for correct answer; -1 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-12-jee.pdf",
                    points: ["Mathematics", "Physics", "Chemistry"],
                  },
                  mindMaps: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Mathematics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
                {
                  exam: "NEET",
                  duration: "Duration: <strong>120 min</strong>",
                  mock_test_pdf:
                    "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-12-neet.pdf",
                  examPatternTitle: "Exam Pattern",
                  examPatterns: [
                    "120 questions – 30 questions per subject (Physics, Chemistry, Botany, Zoology)",
                    "Single Choice MCQs",
                    "+4 for correct answer; -1 for incorrect answer",
                  ],
                  examSchedule: {
                    beforeRegistrationExamDate:
                      "Select your exam date and <br><strong>attempt any time between 9AM - 9PM</strong>",
                    afterRegistrationExamDate:
                      "Exam can be attempted<br><strong>any day from 9 AM to 9 PM</strong>",
                  },
                  syllabus: {
                    heading: "Syllabus",
                    pdfLink:
                      "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-12-neet.pdf",
                    points: ["Physics", "Chemistry", "Botany", "Zoology"],
                  },
                  mindMaps: [
                    {
                      subjectName: "Biology",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                  formulaSheets: [
                    {
                      subjectName: "Biology",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Chemistry",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                    {
                      subjectName: "Physics",
                      subjectIcon: "",
                      pdfs: [
                        {
                          pdfName: "Grade 6 (1)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (2)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                        {
                          pdfName: "Grade 6 (3)",
                          pdfLink:
                            "https://assets.infinitylearn.com/Score26/oneapp/syllabus_pdfs/grade-6.pdf",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    },
    {
      id: "prepareForScore",
      order: 5,
      afterRegistrationWidget: true,
      beforeRegistrationWidget: false,
      response: {
        title: "Prepare for SCORE",
        items: [
          {
            title: "Previous year paper",
            icon: "scorePyqIcon",
          },
          {
            title: "Mock test paper",
            icon: "scoreMockTestPaperIcon",
          },
          {
            title: "Score Curated Playlist",
            icon: "scoreCuratedPlaylistIcon",
          },
          {
            title: "Concept Formula Sheet",
            icon: "scoreFormulaSheetIcon",
            url: "https://www.orimi.com/pdf-test.pdf",
          },
          {
            title: "Mind maps",
            icon: "scoreMindMapsIcon",
            url: "https://www.orimi.com/pdf-test.pdf",
          },
        ],
      },
    },
    {
      id: "registerYourSibiling",
      order: 6,
      beforeRegistrationWidget: false,
      afterRegistrationWidget: true,
      response: {
        title: "Register your Sibiling",
        description:
          "Register them today and help them take the scholarship exam too.",
        registerSiblingButtonText: "Register Sibling",
      },
    },
    {
      id: "faqs",
      order: 7,
      beforeRegistrationWidget: true,
      afterRegistrationWidget: true,
      response: {
        sectionLabel: "FAQ'S",
        description:
          "Everything about SCORE 2026. Can't find what you're looking for? Call us directly.",
        contactButtonText: "Contact Support",
        customerCareIcon: "supportAgent",
        customerCaretitle: "Contact support",
        customerCareDescriptionPrefix: "Please contact support at",
        customerCareDescription: "1800-570-6262",
        customerCareDescriptionSuffix: "to get help with registeration",
        customerCarePhoneNumber: "18005706262",
        items: [
          {
            question: "What is the SCORE Scholarship by Infinity Learn?",
            answer:
              "Infinity Learn’s SCORE Scholarship Test is a national-level talent search and scholarship exam designed to identify meritorious students. It offers scholarships of up to 100% on JEE, NEET, Foundation, and CBSE programs for the 2026–27 academic session.",
          },
          {
            question: "Who is eligible for the SCORE Scholarship in 2026?",
            answer:
              "Students from Classes 4 to 12 are eligible to take SCORE. While the exam includes primary grades, its specialized programs for Classes 6 to 12 focus on IIT-JEE, NEET, Olympiad, and Board preparation. ",
          },
          {
            question: "Is there a registration fee?",
            answer: "No, SCORE Online is free for all eligible students.",
          },
          {
            question:
              "Is there a separate SCORE Scholarship for Class 6 students?",
            answer:
              "Class 6 students are eligible for SCORE Foundation Scholarships. These programs strengthen core concepts in Mathematics, Science, and Logical Reasoning, building a strong foundation for future competitive exams.",
          },
          {
            question:
              "What are the benefits of SCORE for Class 9 and Class 10 students?",
            answer:
              "Students in Classes 9 and 10 can earn tuition scholarships of up to 100% on eligible Foundation and Pre-JEE/NEET courses. Top performers may also receive cash prizes, laptops, ergonomic study setups, and access to premium mentorship.",
          },
          {
            question:
              "Does SCORE offer JEE and NEET scholarships for Classes 11 and 12?",
            answer:
              "Yes. Students in Classes 11 and 12 can earn scholarships of up to 100% for JEE and NEET preparation. These scholarships apply to eligible Infinity Learn’s online courses for the 2026-27 academic session.",
          },
          {
            question:
              "What is the total value of scholarships offered through SCORE Online 2026?",
            answer:
              "SCORE Online 2026 offers scholarships worth ₹350 crore. Multiple students will have the opportunity to earn scholarships applicable to eligible Infinity Learn courses based on their performance.",
          },
          {
            question:
              "How can I win a study setup and laptop through SCORE Online 2026?",
            answer:
              "Top-performing students in SCORE Online 2026 may be selected by Infinity Learn to receive a study setup and laptop as rewards. The selection will be based on students’ exam performance and the applicable reward criteria.",
          },
          {
            question:
              "How does SCORE compare with government scholarships such as NTSE and NMMS?",
            answer:
              "While government scholarships such as NTSE and NMMS primarily provide fixed financial assistance, SCORE offers tuition scholarships of up to 100% on eligible programs. Top performers may also receive cash prizes, gadgets, study setups, mentorship, and access to JEE and NEET preparation programs.",
          },
        ],
      },
    },
  ],
};
